<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SaralaTable
                    ref="table"
                    :model="model"
                    @process="process($event)"
                >
                </SaralaTable>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ErpWebhook from '@/models/ErpWebhook'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new ErpWebhook()
        },
    },

    methods: {
        async process(erpWebhook) {
            let res = await erpWebhook.process()

            if (!res) return

            setTimeout(() => {
                this.$refs.table.getItems()
            }, 500)

            this.$bus.$emit(
                'notify',
                'success',
                'Processamento realizado com sucesso',
            )
        },
    },
}
</script>

<style></style>
